import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import * as Lucide from "lucide-react";

export default function UsageIndicator({ compact = false }) {
  const [u, setU] = useState(null);
  useEffect(() => { api.get("/credits/usage").then((r) => setU(r.data)).catch(() => {}); }, []);
  if (!u) return null;
  // Unlimited / pay-as-you-go plan — show 30d usage without %
  if (!u.monthly_credit_limit) {
    return (
      <div data-testid="usage-indicator" className={`bx-card ${compact ? "p-3" : "p-4"} mt-3`}>
        <div className="flex items-center justify-between gap-2">
          <div className="text-[11px] uppercase tracking-[0.18em] text-slate-500">{u.plan_name || "Pay-as-you-go"}</div>
          <div className="text-[10px] text-emerald-400 font-semibold flex items-center gap-1">
            <Lucide.Infinity size={11} /> NO MONTHLY CAP
          </div>
        </div>
        <div className="text-sm mt-1.5 flex items-center justify-between gap-2">
          <div className="text-slate-400 text-xs">Used in last 30 days</div>
          <div className="text-purple-300 font-bold bx-mono">{(u.used_30d ?? 0).toLocaleString()} cr</div>
        </div>
      </div>
    );
  }
  const pct = Math.min(100, Math.round((u.used_30d / u.monthly_credit_limit) * 100));
  const danger = pct >= 90;
  const warn = pct >= 70 && pct < 90;
  const barColor = danger ? "from-rose-500 to-amber-400" : warn ? "from-amber-400 to-purple-500" : "from-purple-500 to-blue-500";
  return (
    <div data-testid="usage-indicator" className={`bx-card ${compact ? "p-3" : "p-4"} mt-3`}>
      <div className="flex items-center justify-between gap-2">
        <div className="text-[11px] uppercase tracking-[0.18em] text-slate-500">Rolling 30-day · {u.plan_name}</div>
        <div className={`text-xs font-extrabold ${danger ? "text-rose-400" : warn ? "text-amber-300" : "text-emerald-400"}`}>{pct}%</div>
      </div>
      <div className="text-sm mt-1">
        <span className={danger ? "text-rose-400 font-semibold" : "text-purple-300 font-semibold"}>{u.used_30d.toLocaleString()}</span>
        <span className="text-slate-400"> / {u.monthly_credit_limit.toLocaleString()} cr</span>
      </div>
      <div className="mt-2 h-1.5 rounded-full bg-white/10 overflow-hidden">
        <div className={`h-full bg-gradient-to-r ${barColor}`} style={{ width: `${pct}%`, transition: "width .4s ease" }} />
      </div>
      {(warn || danger) && (
        <div className="text-[11px] mt-2 text-amber-300/90 flex items-center justify-between gap-2">
          <span><Lucide.AlertTriangle size={11} className="inline mr-1" /> {danger ? "Nearly at cap." : "Approaching cap."}</span>
          <Link to="/pricing" className="text-purple-300 underline">Upgrade</Link>
        </div>
      )}
    </div>
  );
}
